import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { defaultCompare } from "logic/DefaultCompare";
import { useStore } from "stores/connect";
import { PaginatedList, Select } from "components/common";
import { Alert, ControlLabel, FormGroup, HelpBlock, Button, Panel } from "components/bootstrap";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import Icon from "components/common/Icon";
import ForwarderInputsStore, { ForwarderInputsActions } from "../stores/ForwarderInputsStore";
import ForwarderInputTypesStore from "../stores/ForwarderInputTypesStore";
import { StyledPanel } from "../CommonStyledComponents";
const StyledUl = styled.ul`
  list-style-type: inherit;
  padding-left: 15px;
`;
const InputProfileSwitchForm = ({ currentInputProfile, forwarder, inputProfiles, onSave }) => {
  const { forwarderInputs, pagination: forwarderInputsPagination } = useStore(ForwarderInputsStore);
  const { forwarderInputTypes } = useStore(ForwarderInputTypesStore);
  const [selectedInput, setSelectedInput] = useState(currentInputProfile);
  const [showModal, setShowModal] = useState(false);
  const _openModal = () => setShowModal(true);
  const _closeModal = () => setShowModal(false);
  const _getFormattedInputProfile = () => inputProfiles.filter((ip) => ip.id !== currentInputProfile.id).map((i) => ({ value: i.id, label: i.title })).sort((s1, s2) => defaultCompare(s1.label, s2.label));
  const _onInputProfileChange = (selected) => {
    const selectInputProfile = inputProfiles.find((i) => i.id === selected);
    if (selectInputProfile) {
      setSelectedInput(selectInputProfile);
    }
  };
  const _fetchForwarderInputs = (inputProfileId, page = 1) => {
    ForwarderInputsActions.list({ inputProfileId, page });
  };
  const _handlePageChange = (page) => {
    _fetchForwarderInputs(selectedInput.id, page);
  };
  useEffect(() => {
    _fetchForwarderInputs(selectedInput.id);
  }, [selectedInput]);
  const renderInputs = () => {
    const inputs = forwarderInputs[selectedInput.id];
    if (!inputs) {
      return /* @__PURE__ */ React.createElement("em", null, "Loading Input Profile Inputs...");
    }
    if (inputs.length === 0) {
      return "Input Profile has no configured Inputs.";
    }
    const { page, perPage, total } = forwarderInputsPagination;
    return /* @__PURE__ */ React.createElement(
      PaginatedList,
      {
        totalItems: total,
        activePage: page,
        pageSize: perPage,
        onChange: _handlePageChange,
        showPageSizeSelect: false,
        useQueryParameter: false
      },
      /* @__PURE__ */ React.createElement(StyledUl, null, inputs.map((input) => /* @__PURE__ */ React.createElement("li", { key: input.id }, input.title, " (", (forwarderInputTypes == null ? void 0 : forwarderInputTypes[input.type]) || input.type, ")")))
    );
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { onClick: _openModal, bsStyle: "primary" }, "Switch Input Profile"), /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: showModal,
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, "Switch Input Profile for ", /* @__PURE__ */ React.createElement("em", null, forwarder.title)),
      "data-telemetry-title": "Switch Input Profile for forwarder",
      onSubmitForm: () => {
        onSave(selectedInput);
        _closeModal();
      },
      onCancel: _closeModal,
      submitButtonText: "Save"
    },
    /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(FormGroup, { id: "inputProfileSwitch" }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Next Input Profile"), /* @__PURE__ */ React.createElement(HelpBlock, null, "Select the Input Profile to replace ", /* @__PURE__ */ React.createElement("em", null, currentInputProfile.title), " on this Forwarder."), /* @__PURE__ */ React.createElement(
      Select,
      {
        options: _getFormattedInputProfile(),
        onChange: _onInputProfileChange,
        placeholder: "Select an Input Profile",
        value: selectedInput ? selectedInput.title : void 0
      }
    ), selectedInput && selectedInput.id !== currentInputProfile.id && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, /* @__PURE__ */ React.createElement(Icon, { name: "warning", size: "lg" }), /* @__PURE__ */ React.createElement("strong", null, "Warning"), /* @__PURE__ */ React.createElement("div", null, "This will remove any Inputs currently running on this Forwarder and replace them with Inputs from", " ", /* @__PURE__ */ React.createElement("em", null, selectedInput.title), " Input Profile.")), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(StyledPanel, { bsStyle: "default" }, /* @__PURE__ */ React.createElement(Panel.Heading, null, "Changes overview"), /* @__PURE__ */ React.createElement(Panel.Body, null, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Forwarder"), /* @__PURE__ */ React.createElement("dd", null, forwarder.title), /* @__PURE__ */ React.createElement("dt", null, "Current Input Profile"), /* @__PURE__ */ React.createElement("dd", null, currentInputProfile.title), /* @__PURE__ */ React.createElement("dt", null, "Next Input Profile"), /* @__PURE__ */ React.createElement("dd", null, selectedInput.title), /* @__PURE__ */ React.createElement("dt", null, "Description"), /* @__PURE__ */ React.createElement("dd", null, selectedInput.description || "No description given"), /* @__PURE__ */ React.createElement("dt", null, "Inputs"), /* @__PURE__ */ React.createElement("dd", null, renderInputs())))))))
  ));
};
export default InputProfileSwitchForm;
